var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.96 29.64L29.64 27.96L25.2 23.52V18H22.8V24.48L27.96 29.64ZM24 36C22.34 36 20.78 35.685 19.32 35.055C17.86 34.425 16.59 33.57 15.51 32.49C14.43 31.41 13.575 30.14 12.945 28.68C12.315 27.22 12 25.66 12 24C12 22.34 12.315 20.78 12.945 19.32C13.575 17.86 14.43 16.59 15.51 15.51C16.59 14.43 17.86 13.575 19.32 12.945C20.78 12.315 22.34 12 24 12C25.66 12 27.22 12.315 28.68 12.945C30.14 13.575 31.41 14.43 32.49 15.51C33.57 16.59 34.425 17.86 35.055 19.32C35.685 20.78 36 22.34 36 24C36 25.66 35.685 27.22 35.055 28.68C34.425 30.14 33.57 31.41 32.49 32.49C31.41 33.57 30.14 34.425 28.68 35.055C27.22 35.685 25.66 36 24 36ZM24 33.6C26.66 33.6 28.925 32.665 30.795 30.795C32.665 28.925 33.6 26.66 33.6 24C33.6 21.34 32.665 19.075 30.795 17.205C28.925 15.335 26.66 14.4 24 14.4C21.34 14.4 19.075 15.335 17.205 17.205C15.335 19.075 14.4 21.34 14.4 24C14.4 26.66 15.335 28.925 17.205 30.795C19.075 32.665 21.34 33.6 24 33.6Z",
    fill: "#0284C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.709f8efd74843a3c10d17e255b9f2a23.svg";
export { ForwardRef as ReactComponent };